export default __webpack_public_path__ + "locales/ar-SA/DeleteSelfProfileDialog.json?hash=420c2ddc87494e18d8cfd5849fd35d77";